<template>
    <section class="layout-pt-lg layout-pb-lg bg-accent-2">
      <div class="container">
        <div class="row justify-center">
          <div class="col-lg-10">
            <h2 class="text-center text-62 md:text-30">
              <span class="text-accent-1">GET IN</span>
              TOUCH !
            </h2>
          </div>
        </div>

        <div class="row justify-center pt-60 md:pt-30">
          <div class="col-xl-6 col-lg-8 col-md-10">
            <div class="contactForm">
              <div class="contactForm__field">
                <div class="contactForm__caption">Name</div>
                <input type="text">
              </div>

              <div class="contactForm__field mt-30">
                <div class="contactForm__caption">phone</div>
                <input type="text">
              </div>

              <div class="contactForm__field mt-30">
                <div class="contactForm__caption">emaıl</div>
                <input type="text">
              </div>

              <div class="mt-30">
                <button class="button -md -dark-1 bg-accent-1 text-white col-12">
                  SEND REQUEST
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>


<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'ContactForm',
 
  components: {
    BlockSymbol,
  },

  mixins: [ComponentMixin],


});
</script>

<style scoped>
.block {
  font-size: 24em;
  font-weight: 900;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: 1;
  margin: 0;
  padding: 0;
  position: absolute;
}
</style>
